import { S3_BASE_URL } from '../../CompanyData/DefaultData';

export const getAssetUrl = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path; // already a full URL
  return `${S3_BASE_URL}${path}`;
};